import React, { Component } from 'react';
import StepContainer from '../../StepContainer';
import StepButtons from '../../StepButtons';
import styled from 'styled-components';
import RadioInput from 'components/RadioInput';
import ProgressBarSteps from 'components/ProgressBarSteps';

const TravelPersonalityTestContainer = styled.div`
  margin: 90px 20%;
  @media (max-width: 1000px) {
    margin-left: 15%;
    margin-right: 15%;
  }
`;
const ProgresBarContainer = styled.div`
  width: 14%;
  position: absolute;
  bottom: 40px;
  right: 100px;
  @media (max-width: 875px) {
    display: none;
  }
`;

const CurrentStepIndicator = styled.p`
  color: #9e9e9e;
  font-size: 14px;
  text-align: center;
`;

class TravelPersonalityTestView extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { changeStep, handleChange, data, stepFields } = this.props;
    const { localStep } = data;

    return (
      <>
        <StepContainer subtitle={stepFields.label}>
          <TravelPersonalityTestContainer>
            <RadioInput
              name={stepFields.name}
              label={stepFields.title}
              options={stepFields.options}
              handleChange={handleChange}
              currentValue={data[stepFields.name]}
              verticalAlign
            />
          </TravelPersonalityTestContainer>
          <ProgresBarContainer>
            <ProgressBarSteps percent={Math.round((localStep * 100) / 10)} />
          </ProgresBarContainer>
          <CurrentStepIndicator>Part 3 of 3</CurrentStepIndicator>
          <StepButtons
            backStep={() => changeStep(localStep - 1)}
            nextStep={() => changeStep(localStep + 1)}
          />
        </StepContainer>
      </>
    );
  }
}

export default TravelPersonalityTestView;
